<template>
  <span
    :class="[
      'logo',
    ]"
  >
    <span class="logo__inner">
      <component :is="small ? ImageBrandLogoSmall : ImageBrandLogo" class="logo__image" />
      <span class="visuallyhidden">{{ label }}</span>
    </span>
  </span>
</template>

<script>
// Models
import config from 'config';

// Images
import ImageBrandLogo from 'images/brand/logo.svg?inline';
import ImageBrandLogoSmall from 'images/brand/logo-small.svg?inline';

// Export
export default {
  name: `module-logo`,

  // Props
  props: {
    small: {
      type: Boolean,
      default: false,
    },
  },

  // Data
  data() {
    return {
      ImageBrandLogo,
      ImageBrandLogoSmall,
    };
  },
  computed: {
    label() {
      return config.name;
    },
  },
};
</script>



// WEBPACK FOOTER //
// Logo.vue?79513797